import React from 'react';
import '../src/styles/global.scss';
import { Main } from './components/Main';

function App() {
  return <Main />;
}

export default App;
